import React from 'react';
import { BooleanInput, SearchInput, ReferenceInput, AutocompleteInput } from 'react-admin';

import GetAppIcon from '@mui/icons-material/GetApp';

import BudgetRow from './BudgetRow';
import List, { ListActions } from '../common/views/List';
import IconButton from '../common/buttons/IconButton';

import { API_URL } from '../../services/settings';


const BudgetListActions = (props) => (
    <ListActions {...props}>
        <IconButton icon={<GetAppIcon />} component="a" href={`${API_URL}/budgets/export.xls`}>Export</IconButton>
    </ListActions>
);

const BudgetFilters = [
    <SearchInput source="q" alwaysOn />,
    <ReferenceInput source="customer_id" reference="customers" sort={{ field: 'name', order: 'ASC' }} allowEmpty alwaysOn>
        <AutocompleteInput optionText="name" />
    </ReferenceInput>,
    <ReferenceInput source="project_id" reference="projects" sort={{ field: 'name', order: 'ASC' }} allowEmpty alwaysOn>
        <AutocompleteInput optionText="name" />
    </ReferenceInput>,
    <BooleanInput source="is_active" alwaysOn />,
];

const filterDefaultValues = {
};

const BudgetList = props => (
    <List {...props} filters={BudgetFilters} filterDefaultValues={filterDefaultValues} actions={<BudgetListActions />} exporter={false} >
        <BudgetRow />
    </List>
);

export default BudgetList;